import { render, staticRenderFns } from "./ModalConfigGoogleAds.vue?vue&type=template&id=bbdd6caa&"
import script from "./ModalConfigGoogleAds.vue?vue&type=script&lang=js&"
export * from "./ModalConfigGoogleAds.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigGoogleAds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports